const Open = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"  width="18" height="18"
         viewBox="0 0 18 18">
      <defs>
        <clipPath id="clip-path">
          <rect id="Rectangle_5098" data-name="Rectangle 5098" width="18" height="18" transform="translate(1588 1218)"
                fill="#fff" stroke="#707070" strokeWidth="1"/>
        </clipPath>
        <linearGradient id="linear-gradient" x1="0.923" y1="0.515" x2="-0.324" y2="0.5"
                        gradientUnits="objectBoundingBox">
          <stop offset="0" stopColor="#175a76"/>
          <stop offset="1" stopColor="#bfdde7"/>
        </linearGradient>
      </defs>
      <g id="Mask_Group_592" data-name="Mask Group 592" transform="translate(-1588 -1218)" >
        <g id="Group_18159" data-name="Group 18159" transform="translate(1589.548 1218.525)">
          <g id="fast-forward_2_" data-name="fast-forward (2)" transform="translate(14.933 0) rotate(90)">
            <g id="Group_18152" data-name="Group 18152" transform="translate(7.383)">
              <g id="Group_18151" data-name="Group 18151" transform="translate(0)">
                <path id="Path_59476" data-name="Path 59476"
                      d="M8.511,6.421,2.522.432a1.478,1.478,0,1,0-2.09,2.09L5.376,7.466.432,12.41a1.478,1.478,0,1,0,2.09,2.09L8.511,8.511a1.478,1.478,0,0,0,0-2.09Z"
                      fill="url(#linear-gradient)"/>
              </g>
            </g>
            <g id="Group_18154" data-name="Group 18154" transform="translate(14.116 6.313)">
              <g id="Group_18153" data-name="Group 18153" transform="translate(0 0)">
                <path id="Path_59477" data-name="Path 59477"
                      d="M.922.5.506.086A.3.3,0,1,0,.089.509L.5.919A.3.3,0,0,0,.922.5Z" fill="#fff"/>
              </g>
            </g>
            <g id="Group_18156" data-name="Group 18156" transform="translate(8.744 1.011)">
              <g id="Group_18155" data-name="Group 18155" transform="translate(0 0)">
                <path id="Path_59478" data-name="Path 59478"
                      d="M5.1,4.612.506.086A.3.3,0,0,0,.089.509L4.681,5.035A.3.3,0,0,0,5.1,4.612Z" fill="#fff"/>
              </g>
            </g>
            <g id="Group_18158" data-name="Group 18158">
              <g id="Group_18157" data-name="Group 18157">
                <path id="Path_59479" data-name="Path 59479"
                      d="M8.511,6.421,2.522.432a1.478,1.478,0,1,0-2.09,2.09L5.376,7.466.432,12.41a1.478,1.478,0,1,0,2.09,2.09L8.511,8.511a1.478,1.478,0,0,0,0-2.09Z"
                      fill="url(#linear-gradient)"/>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Open;